





























import { Component, Vue, Prop } from 'vue-property-decorator';

import WinnerCard from './WinnerCard.vue';

@Component({
  components: { WinnerCard }
})
export default class Winners extends Vue {
  @Prop() private winners!: object[];

  private checkIfThereAreWinners(key: string) {
    for (const index in this.winners) {
      if (this.winners.hasOwnProperty(index)) {
        const element: any = this.winners[index];

        if (element && element[key] && Object.keys(element[key]).length) {
          return true;
        }
      }
    }

    return false;
  }

  get twoOrMoreWnners() {
    return this.winners.length > 1;
  }
}
